import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { damagesQueryKeys } from "./queryKeys"

export function useDamages(networkCondition, queryParameters, config = {}) {
    const parameters = useExtendWithSubnetworks({
        ...queryParameters,
        as_geojson: true,
    }, API_MODULE_ROADWAY)
    const { enabled = networkCondition?.year } = config

    const key = damagesQueryKeys["list"]({ year: networkCondition?.year, ...parameters })
    const url = "damages/"

    return useRoadQuery(
        url,
        key,
        parameters,
        {
            ...config,
            enabled,
        },
    )
}
